var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"model-item",attrs:{"href":`${_vm.laximoPath}auto/lx/catalog?code=${_vm.item.laximoCode}`}},[_c('base-icon',{staticClass:"model-item__icon",attrs:{"sprite":_vm.sprite,"name":_vm.item.alias,"width":"40","height":"40"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }